// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__17M89","description":"PatientConsentPreview_description__2kmnb"};